import React, { ChangeEvent, useState } from "react";
import { Box } from "@material-ui/core";
import CustomTextField from "../../shared/CustomTextField";
import ButtonNav from "../../shared/NavBar/ButtonNav";
import FormDialog from "../../shared/FormDialog";
import { useDispatch, useSelector } from "react-redux";
import { setErrors, setSuccessMessage } from "../../store/alerts/alertsActions";
import { PASSWORD_VALIDATOR } from "../../messages/errorsMessages";
import useApiRequest from "../../utils/hook/useApiRequest";
import { REGISTER_WEBUSER } from "../../api/apiRoutes";
import { State } from "../../store";

interface IProps {
  open: boolean;
  onClose: () => void;
}

const ChangePassForm: React.FC<IProps> = ({ open, onClose }: IProps) => {
  const [newPass, setNewPass] = useState("");
  const [repeatPass, setRepeatPass] = useState("");
  const dispatch = useDispatch();
  const { put } = useApiRequest();
  const webUser = useSelector((state: State) => state.auth.webUser);

  const onSubmit = async () => {
    if (validatePass()) {
      const { isError } = await put(REGISTER_WEBUSER, { ...webUser, password: newPass });
      if (!isError) {
        dispatch(setSuccessMessage("Twoje hasło zostało zmienione"));
        onClose();
      }
    }
  };

  const validatePass = () => {
    if (newPass === "" || repeatPass === "") {
      dispatch(setErrors(["Uzupełnij pola"]));
      return false;
    }
    if (newPass !== repeatPass) {
      dispatch(setErrors(["Podane hasła są różne"]));
      return false;
    }
    if (!newPass.match(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,64}$/)) {
      dispatch(setErrors([PASSWORD_VALIDATOR]));
      return false;
    }

    return true;
  };

  return (
    <FormDialog open={open} title={`Zmień hasło`} onClose={onClose} showTitle={true} hideActions={true}>
      <Box my={3} style={{ width: "60%", marginLeft: "20%" }}>
        <CustomTextField
          label={"Nowe hasło"}
          name={"newPass"}
          margin={"dense"}
          fullWidth
          value={newPass}
          onChange={(event: ChangeEvent<HTMLInputElement>) => setNewPass(event.target.value)}
          type={"password"}
        />

        <CustomTextField
          label={"Powtórz hasło"}
          name={"repeatPass"}
          margin={"dense"}
          fullWidth
          value={repeatPass}
          onChange={(event: ChangeEvent<HTMLInputElement>) => setRepeatPass(event.target.value)}
          type={"password"}
        />
      </Box>
      <Box my={3} style={{ width: "60%", marginLeft: "20%" }}>
        <ButtonNav type={"button"} onClick={onSubmit} fullWidth={true}>
          Zapisz
        </ButtonNav>
      </Box>
    </FormDialog>
  );
};

export default ChangePassForm;
